import { eCommentType } from './eCommentType';

export const externalCommentTypes = [
  eCommentType.closing,
  eCommentType.curative,
  eCommentType.examination,
  eCommentType.funding,
  eCommentType.general,
  eCommentType.inboundCall,
  eCommentType.orderManagement,
  eCommentType.policy,
  eCommentType.postFunding,
  eCommentType.recording,
  eCommentType.search,
  eCommentType.shortage,
  eCommentType.underwriting,
];
